import { Layer } from "@/interfaces/template.interface";
import LayerList from "./LayerList";
import { ReactNode } from "react";

interface LayerFilter {
  templateId?: string;
}

interface Props {
  filter?: LayerFilter;
  header?: ReactNode;
  onSelect?: (items: Layer[]) => void;
}

export default function LayerManagement({ filter, header, onSelect }: Props) {
  return (
    <div className="flex h-full w-full flex-1 overflow-auto">
      <div className="h-full flex-1 overflow-auto">
        <LayerList filter={filter} header={header} onSelect={onSelect} />
      </div>
    </div>
  );
}
